import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { href: "#hot", label: "热瓜榜" },
  { href: "#lian", label: "联动瓜" },
  { href: "#chuan", label: "串门" },
  { href: "#kua", label: "跨圈追踪" },
  { href: "#quan", label: "圈外爆料" },
  { href: "#guide", label: "吃瓜指南" },
  { href: "#about", label: "关于我们" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-all duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 shadow-sm backdrop-blur"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-3 md:px-6">
        <a
          href="#top"
          className="group flex items-center gap-2.5"
          aria-label="71吃瓜 首页"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-500 text-xl text-background-50 transition-transform group-hover:rotate-12">
            <i className="ri-vip-crown-2-fill" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-2xl text-foreground-900">
              71<span className="text-primary-600">吃瓜</span>
            </span>
            <span className="mt-1 text-[11px] tracking-wide text-foreground-500">
              联动 · 串门 · 跨圈小料
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#subscribe"
            className="ml-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-accent-600"
          >
            订阅更新
          </a>
        </nav>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-xl bg-background-100 text-xl text-foreground-800 lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden"
          aria-label="移动端导航"
        >
          <div className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-lg bg-accent-500 px-3 py-2.5 text-center text-sm text-background-50"
            >
              订阅更新
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}